module.exports = __webpack_public_path__ + "static/media/Conway.a8a664ae.jpg";